import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'weaving_of_textiles'

export const dataPointDefinition = {
  retracedId: 'weaving_of_textiles',
  name: 'Weaving of textiles',
  description:
    'This includes, e.g., manufacture of broad woven cotton-type, woolen-type, worsted-type or silk-type fabrics, including from mixtures or artificial or synthetic yarns; manufacture of other broad woven fabrics, using flax, ramie, hemp, jute, bast fibers and special yarns; manufacture of woven pile or ',
  meta: {
    slcpMeta: {
      key: 'fp-pro-23',
      number: 'FP-PRO-2-2',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'fp-pro-2',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'Facility Profile',
      verificationSelectionOptList: 'verf-f-list',
      nonComOptionList: '',
      nonCompliance: '',
      humanShowHide: '[1]',
      machineShowHide: '[1]',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'fp-pro-23', version: '1.7.0', provider: 'slcp'}],
  sortingId: 28850,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
